/**
 * Currencies that return 400 from Kayak search-in-place (prod probe, May 2026).
 * All other valid ISO 4217 codes are passed through.
 */
export const KAYAK_SEARCH_UNSUPPORTED_CURRENCIES = [
	'ANG',
	'UZS',
	'VES',
	'VND',
	'VUV',
	'WST',
	'XAF',
	'XCD',
	'XOF',
	'XPF',
	'YER',
	'ZMW',
	'ZWL',
] as const

export type KayakSearchUnsupportedCurrency =
	(typeof KAYAK_SEARCH_UNSUPPORTED_CURRENCIES)[number]
